import { tv } from "../../variants/index.js";
const sellingPointVariants = tv({
    slots: {
        baseSlot: 'flex w-full',
        discSlot: 'flex',
        badgeSlot: 'flex',
        actionSlot: 'flex',
        mainContentContainerSlot: 'flex grow flex-col gap-1'
    },
    variants: {
        palette: {
            neutral: {},
            success: {},
            promoPrimary: {},
            customer: {},
            benefit: {}
        },
        emphasis: {
            regular: {
                mainContentContainerSlot: 'text-neutral-13'
            },
            medium: {
                mainContentContainerSlot: 'text-neutral-13'
            },
            bold: {
                mainContentContainerSlot: 'text-neutral-1'
            }
        },
        orientation: {
            horizontal: {
                baseSlot: 'items-center'
            },
            vertical: {
                baseSlot: 'flex-col items-center',
                badgeSlot: 'justify-center',
                actionSlot: 'justify-center',
                mainContentContainerSlot: 'items-center text-center'
            }
        },
        size: {
            sm: {
                baseSlot: 'gap-3'
            },
            md: {
                baseSlot: 'gap-4'
            }
        }
    },
    defaultVariants: {
        palette: 'neutral',
        emphasis: 'regular',
        orientation: 'horizontal',
        size: 'md'
    }
});
const sellingPointPalettes = Object.keys(sellingPointVariants.variants.palette);
const sellingPointOrientations = Object.keys(sellingPointVariants.variants.orientation);
export { sellingPointOrientations, sellingPointPalettes, sellingPointVariants };
